import axios from 'axios';

import { getStringItem } from '../session-storage';
import { accessTokenKey } from '../config';


const extractJSON = response => response.data;

const domain = window._env_.REACT_APP_API_URL;

// eslint-disable-next-line no-underscore-dangle
const getAccessToken = () => getStringItem(accessTokenKey) || window._env_.REACT_APP_ACCESS_TOKEN;

const globalApi = () => ({
  endpoint,
  method,
  mapResult = x => (x),
  ...options
}) => axios({
  url: `${domain}${endpoint}`,
  headers: getAccessToken()
    ? {
      Authorization: `bearer ${getAccessToken()}`,
      version: '1.18.0',
    }
    : {
      version: '1.18.0',
    },
  method: method || 'GET',
  ...options,
})
  .then(extractJSON)
  .then(mapResult)
  .catch((error) => {
    // if (error?.response?.data?.buttons?.[0]?.action === "reLogin") {
    //   error.response.data.type = 'Toast';
    // }
    if (error.response) {
      // eslint-disable-next-line
      error.response.data.source = 'webApp';
    }
    throw mapResult({ error });
  });

export default globalApi;
